/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const tableStateStatusEnumSchema = z
	.enum(["free", "occupied", "reserved", "unknown"])
	.describe("* `free` - Свободен\n* `occupied` - Занят заказом\n* `reserved` - Идёт бронь\n* `unknown` - Касса не ответила");
